import {
  trackerObj,
  orderTypeList,
  codList,
  interceptionList,
  OverseasdList,
  searchTypeObj,
  typeList,
  unpackList,
} from "./localData.js";
import { getCity } from "@/api/system/city";
import {searchCustomer} from "@/api/tracker/sea";
export const header = ({ that, type }) => {
  let all = type == "all" ? true : false; //全部订单
  let inbound = type == "inbound" ? true : false; //入库单
  let customerWait = type == "customer-wait" ? true : false; //待客户确认重量
  let customerIn = type == "customer-in" ? true : false; //客户拦截
  let del = type == "delete" ? true : false; //删除订单
  return {
    searchs: [
      {
        key: "time_type",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("time") + that.$t("type");
        },
        options: [],
        getFun: "getTimeType",
        isDefault: "key",
        config: { label: "desc", value: "key" },
        show: () => !del,
      },
      {
        key: "startTime",
        component: "DatePicker",
        placeholder() {
          return that.$t("start") + that.$t("time");
        },
        bind: {
          type: "datetime",
          options: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          },
          style: {
            width: "175px",
          },
        },
        methods: {
          "on-change"({ searchForm }) {
            searchForm.startTime = searchForm.startTime
              ? that.format.timeFormat(searchForm.startTime)
              : "";
          },
        },
      },
      {
        key: "endTime",
        component: "DatePicker",
        placeholder() {
          return that.$t("end") + that.$t("time");
        },
        bind: {
          type: "datetime",
          options: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          },
          style: {
            width: "175px",
          },
        },
        methods: {
          "on-change"({ searchForm }) {
            let time = this.$page.format.timeFormat(searchForm.endTime);
            if (time.slice(-8) === "00:00:00") {
              time = time.split(" ")[0] + " " + "23:59:59";
              searchForm["endTime"] = time;
            }
          },
        },
      },
      {
        key: "type",
        component: "Select",
        bind: {
          style: "width:150px",
          multiple: true,
          "max-tag-count": 1,
        },
        placeholder() {
          return that.$t("order_type_t");
        },
        options: [],
        // config: {
        //   label: ({ row }) => {
        //     return that.$t(row.label);
        //   }
        // },
        getFun: "getSelectType",
        searchData: "ORDERS_TYPE",
        isPublic: true,
        show: () => !del,
      },
      {
        key: "WAIT_CONFIRM_TYPE",
        component: "Select",
        bind: {
          style: "width:150px",
          multiple: true,
          "max-tag-count": 1,
        },
        placeholder() {
          return that.$tz("装袋失败原因");
        },
        options: [],
        // config: {
        //   label: ({ row }) => {
        //     return that.$t(row.label);
        //   }
        // },
        getFun: "getSelectType",
        searchData: "WAIT_CONFIRM_TYPE",
        isPublic: true,
        show: () => !del,
      },
      {
        key: "confirmStatus",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        show: () => inbound,
        placeholder() {
          return that.$t("type");
        },
        options: typeList,
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
      },
      {
        key: "clientId",
        component: "AutoComplete",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("clientName");
        },
        data: [],
        onSearch: ({value, item}) => {
          if (value.length >= 2) {
            searchCustomer(value).then(res => {
              item.data = res.data.payload
            })
          }
        }
        // options: [],
        // config: { label: "account", value: "id" },
        // // show: () => false,
        // getFun: "getAllClient",
        // searchData: {
        //   key_fields: 1,
        // },
      },
      {
        key: "serviceId",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("serviceAccount");
        },
        options: [],
        // config: { label: "account", value: "id" },
        getFun: "getAllService",
        getFilter: [1, 2, 3],
        // searchData: {
        //   standard: "CustomerService",
        // },
      },
      {
        key: "salesmanId",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("salesman");
        },
        options: [],
        // config: { label: "account", value: "id" },
        getFun: "getAllService",
        getFilter: [5],
        // searchData: {
        //   standard: "Salesman",
        // },
      },
      {
        key: "statusCode",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("tracker_code");
        },
        options: [],
        config: { label: "tracker_code", value: "tracker_code" },
        // show: () => false,
        getFun: "getStatus",
        show: () => all,
        isSearch: true, //当路由协当前参，带此值时自动刷新列表
      },
      {
        key: "current_processor",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("NextProcessing");
        },
        options: [],
        // config: {
        //   label: ({ row }) => {
        //     return that.$t(row.label);
        //   }
        // },
        getFun: "getSelectType",
        searchData: "NEXT_STEP_TYPE",
        isPublic: true,
        show: () => all,
      },
      {
        key: "deliver",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("localFaction");
        },
        options: [],
        config: {
          label: "agent_name",
          value: "agent_name",
        },
        getFun: "getAgent",
        searchData: {
          agent_type: "bag",
          status: "YES",
          types: "DELIVERY",
        },
        show: () => !del,
      },
      {
        key: "trackerCode",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return del
            ? that.$t("tracker_code")
            : that.$t("pod") + that.$t("tip");
        },
        options: trackerObj,
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
      },
      {
        key: "ddx",
        component: "Select",
        placeholder() {
          return that.$t("select") + that.$t("taxationType");
        },
        clearable: true,
        options: [
          { label: that.$t("DDU"), value: 'DDU' },
          { label: that.$t("DDP"), value: 'DDP' },
        ],
        bind: {
          style: "width:150px",
        },
      },
      {
        key: "from_country",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("allow_depart");
        },
        options: [],
        config: { label: "title", value: "code" },
        getFun: "getCountry",
        searchData: {
          allow_depart: 1,
        },
        show: () => !del,
      },
      {
        key: "countryCode",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return del ? that.$t("countryName") : that.$t("allow_arrive");
        },
        options: [],
        config: { label: "title", value: "code" },
        getFun: "getCountry",
        searchData: del
          ? ""
          : {
            allow_arrive: 1,
          },
        methods: {
          async "on-change"({ value, field, fields, searchForm }) {
            let country = field.options.find(t => t.code === searchForm.countryCode)
            fields.forEach(async (el) => {
              if (el.key == "city_id") {
                if (country) {
                  let res = (await getCity({ country_id: country.id })).data
                    .payload.rows;
                  el.options = res;
                } else {
                  el.options = [];
                }
                searchForm[el.key] = "";
                return;
              }
            });
          },
        }
      },
      {
        key: "city_id",
        component: "Select",
        placeholder() {
          return this.$t("select") + this.$t("city_name");
        },
        clearable: true,
        options: [],
        config: {
          label: "title",
          value: "id",
        },
      },
      {
        key: "codeStatus",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("orderType");
        },
        options: [],
        getFun: "getSelectType",
        searchData: "ORDER_STATUS",
        isPublic: true,
        show: () => all || del,
      },
      {
        key: "is_unpack",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("ECommercePacket");
        },
        options: [],
        getFun: "getSelectType",
        searchData: "OUTBOUND_SELECT_TYPE",
        isPublic: true,
        // config: {
        //   label: ({ row }) => {
        //     return that.$t(row.label);
        //   }
        // },
        show: () => !del,
      },
      {
        key: "codType",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("order_type" + (type == 'customer-in' ? '1' : ''));
        },
        options: [],
        getFun: "getSelectType",
        searchData: "COD_TYPE",
        isPublic: true,
        show: () => !del,
      },
      {
        key: "interception_phase",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("barPhase");
        },
        options: interceptionList,
        show: () => customerIn,
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
      },

      {
        key: "is_warehouse",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("Overseasdistribution");
        },
        options: OverseasdList,
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all,
      },
      {
        key: "warehouse",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("warehouseName");
        },
        options: [],
        config: {
          label: "title",
          value: "id",
        },
        getFun: "getWarehouse",
        searchData: true
          ? { is_oversea: "YES", status: "ENABLE" }
          : { is_oversea: "NO", status: "ENABLE" },
        show: () => !customerWait && !customerIn && !del,
      },
      {
        key: "isPackage",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("Bagging");
        },
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" },
        ],
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all || inbound,
      },
      {
        key: "service_type",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("orther") + that.$t("cost_t");
        },
        options: [],
        getFun: "getOtherFee",
        show: () => all,
      },

      {
        key: "ownership",
        component: "Select",
        placeholder() {
          return this.$t("ownership");
        },
        clearable: true,
        getFun: "getCompanyConfig",
        isPublic: true,
        searchData: "company",
        options: [],
        config: { label: "title", value: "id" },
      },
      {
        key: "is_remarks",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("Remarks");
        },
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" },
        ],
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all,
      },
      {
        key: "is_cancel",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("returnPick") + that.$t("cancel");
        },
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" },
        ],
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all,
      },
      {
        key: "unbox",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$tz("是否开箱");
        },
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" },
        ],
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all,
      },
      {
        key: "loop",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$tz("是否,闭环");
        },
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" },
        ],
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => all,
      },
      {
        key: "delivery_mode",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("delivery") + that.$t("mode");
        },
        options: [],
        getFun: "getSelectType",
        searchData: "AE_IL_DELIVERY_MODE",
        isPublic: true,
        show: () => all,
      },
      // {
      //   key: "group_name",
      //   component: "Select",
      //   bind: {
      //     style: "width:150px",
      //   },
      //   placeholder() {
      //     return that.$t("group_name1");
      //   },
      //   options: [],
      //   getFun: "getGroupName",
      //   show: () => all,
      // },
      // {
      //   key: 'circuit_id',
      //   placeholder() {
      //     return that.$tz('派送线路')
      //   },
      //   component: 'Select',
      //   options: [],
      //   optionsFn: 'getCircuit',
      //   optionsKey: '',
      //   show: () => all,
      // },
      {
        key: "searchType",
        component: "Select",
        bind: {
          style: "width:150px",
        },
        placeholder() {
          return that.$t("keywords_type");
        },
        // options: searchTypeObj,
        default: "airway_number",
        options: [],
        getFun: "getSelectType",
        searchData: "OMS_ALL_ORDERS_KEYWORDS",
        isPublic: true,
        config: {
          label: ({ row }) => {
            return that.$t(row.label);
          },
        },
        show: () => !del,
      },
      {
        key: "keywords",
        placeholder() {
          return that.$t("keyword");
        },
        component: "Input",
        bind: {
          type: "textarea",
          rows: 1,
        },
      },
    ],
    btns: {
      list: [
        {
          name: () => that.$t("print"),
          label: true,
          show: () => all || inbound,
        },
        {
          name: () => that.$t("export"),
          type: "export",
          fnName: "export",
          bind: {
            type: "primary",
            icon: "md-arrow-down",
          },
          disabled() {
            return customerWait && !that.selectAll.length;
          }
        },
        {
          name: () => that.$t("confirmWeight"),
          type: "weighing",
          fnName: "weighing",
          id: 451,
          show: () => customerWait,
          disabled() {
            return !that.selectAll.length;
          },
          bind: {
            type: "warning",
          },
        },
        {
          name: () => that.$t("IncomingInspection"),
          type: "checkWeight",
          fnName: "checkWeight",
          show: () => inbound,
          id: 559,
          bind: {
            type: "warning",
          },
        },
        {
          name: () => that.$t("add") + that.$t("order_desc"),
          type: "remark",
          fnName: "remarkFun",
          disabled() {
            return !that.selectAll.length;
          },
          show: () => all || inbound,
          bind: {
            type: "success",
          },
        },
        {
          name: () => that.$t("add") + that.$t("orther") + that.$t("cost_t"),
          type: "orderCost",
          fnName: "orderCostFun",
          disabled() {
            return !that.selectAll.length;
          },
          show: () => all,
          bind: {
            type: "success",
          },
        },
        {
          name: () => that.$t("Invalid"),
          type: "Invalid",
          fnName: "Invalid",
          disabled() {
            return !that.selectAll.length;
          },
          show: () => all,
          bind: {
            type: "error",
          },
          id: 1535,
        },
        {
          name: () => that.$t("orderBlock"),
          type: "orderBlock",
          fnName: "orderBlock",
          disabled() {
            return !that.selectAll.length;
          },
          show: () => all,
          bind: {
            type: "error",
          },
        },
        {
          name: () => that.$t("printLabel"),
          type: "print",
          fnName: "print",
          bind: {
            type: "primary",
            // icon: "md-swap",
          },
        },
        {
          name: () => that.$tz('TEMU拆段转专线'),
          type: 'changeTemuAccount',
          fnName: 'changeTemuAccount',
          bind: {
            type: 'primary',
          },
          id:1988,
          show: () => inbound,
        },
        {
          name: () => that.$tz("解除拦截"),
          type: "int",
          fnName: "int",
          bind: {
            type: "primary",
            // icon: "md-swap",
          },
          show: () => customerIn,
          disabled() {
            return !that.selectAll.length;
          },
          id: 1709
        },
        // {
        //   name: () => that.$tz("是否开箱"),
        //   type: "unbox",
        //   fnName: "unbox",
        //   bind: {
        //     type: "primary",
        //     // icon: "md-swap",
        //   },
        //   show: () => all,
        //   disabled() {
        //     return !that.selectAll.length;
        //   },
        // },
      ],
      methods: {
        changeTemuAccount() {
          that.getModal('changeTemuAccount').open({})
        },
        int() {
          that.$Modal.confirm({
            title: that.$tz('是否,解除拦截'),
            width: 300,
            content: that.$t('titleModal'),
            onOk: () => {
              that.handleRequestMethods('removeBlocks', { airway_number: that.selectAll.map((item) => item.airway_number) }, true, true).then(
                res => {
                  that.getList()
                }
              );
            }
          })
        },
        unbox() {
          that.getModal('unbox').open({ airway_number: that.selectAll.map((item) => item.airway_number) })
        },
        print() {
          that.getModal('printLabel').open()
        },
        orderBlock({ row }) {
          that.$Modal.confirm({
            title:
              that.$t("whether") +
              that.$t("confirm") +
              that.$t("orderBlock") +
              "?",
            onOk: () => {
              that.handleRequestMethods('blockOrder', { airwayBill: that.selectAll.map((item) => item.airway_number) }).then(res => {
                that.$Message.success(res.msg);
                that.getList()
              })
            },
          });
        },
        Invalid({ row }) {
          that.$Modal.confirm({
            title:
              that.$t("whether") +
              that.$t("confirm") +
              that.$t("Invalid") +
              "?",
            onOk: () => {
              that.handleRequestMethods('batchDelOrder', { airway_number: that.selectAll.map((item) => item.airway_number) }).then(res => {
                that.$Message.success(res.msg);
                that.getList()
              })
            },
          });
        },
        export({ searchForm }) {
          if (customerWait) {
            return this.exportExc()
          }
          searchForm["exportExcel"] = 1;
          searchForm["page"] = this.pageConfig.page;
          if (that.selectAll.length) {
            searchForm["order_id"] = that.selectAll.map((item) => item.id);
          } else {
            delete searchForm["order_id"];
          }
          that.openLoading();
          that
            .handleRequestMethods("list", searchForm, false, true)
            .then((res) => {
              window.open(that.$globalUrl + res.payload, "_blank");
            });
        },
        downFun({ field }) {
          let data = null;
          if (field.fun === "postSheet") {
            data = {
              miniLabel: ["mini", 'mini2'].includes(field.type) ? true : false,
              ignoreInvoice: field.type == "mini2",
              specialLable: field.type == "medium" ? true : false,
              single: true,
              orders: that.selectAll.map((item) => item.airway_number),
            };
          } else {
            data = {
              type: "Invoice",
              merge: true,
              rule: "standard",
              orderNo: that.selectAll.map((item) => item.airway_number),
            };
          }
          that.handleRequestMethods(field.fun, data).then((res) => {
            if (field.fun === "postSheet") {
              if (res.payload.length > 1) {
                that.getModal("sheetList").open(null, function () {
                  this.setTitle(that.$t("sheet"));
                  this.list = res.payload;
                });
              } else {
                window.open(res.payload[0].link, "_blank");
              }
            } else {
              window.open(that.$globalUrl + res.data[0].url, "_blank");
            }
          });
        },
        weighing() {
          that.$Modal.confirm({
            title:
              that.$t("whether") +
              that.$t("confirm") +
              that.$t("selected") +
              that.$t("invoiceWeight") +
              "?",
            onOk: () => {
              let airway_number = that.selectAll.map(
                (item) => item.airway_number
              );
              that
                .handleRequestMethods("confirmWeight", { airway_number }, true)
                .then((res) => {
                  that.getList(that.searchFrom);
                });
            },
          });
        },
        checkWeight() {
          that.getModal("checkWeight").open({}, function () {
            this.setTitle(that.$t("IncomingInspection"));
          });
        },
        remarkFun() {
          let airway_number = this.selectAll.map((item) => item.airway_number);
          that.getModal("addRemark").open({ airway_number }, function () {
            this.setTitle(that.$t("add") + that.$t("order_desc"));
          });
        },
        orderCostFun() {
          let airway_number = this.selectAll.map((item) => item.airway_number);
          that.getModal("ortherCost").open({ airway_number }, function () {
            this.setTitle(
              that.$t("add") + that.$t("orther") + that.$t("cost_t")
            );
          });
        },
      },
    },
  };
};
